import { useNavigate } from 'react-router';
import { LogOut, UserCircle } from 'lucide-react';
import { usePartnerAuthStore } from '@/stores/partnerAuthStore';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export function SidebarUserMenu() {
  const { partner, logout } = usePartnerAuthStore();
  const navigate = useNavigate();

  const initials = (partner?.name ?? '')
    .split(' ')
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <div className="border-t border-primary-foreground/10 p-4">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="h-auto w-full justify-start gap-3 px-2 py-2 text-left hover:bg-primary-foreground/10"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-accent/50 bg-secondary text-xs font-medium text-secondary-foreground">
              {initials}
            </span>
            <span className="min-w-0 leading-tight">
              <span className="block truncate text-sm font-medium text-primary-foreground">
                {partner?.name}
              </span>
              <span className="block text-xs text-primary-foreground/60">{partner?.role}</span>
            </span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" side="top" className="w-56">
          <DropdownMenuItem className="cursor-pointer gap-2" onClick={() => navigate('/profile')}>
            <UserCircle className="h-4 w-4" />
            Profile settings
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem className="cursor-pointer gap-2 text-destructive" onClick={() => void logout()}>
            <LogOut className="h-4 w-4" />
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
